const RouterAttend = [
    {
        path: '/',
        name: 'AttendServiceClosed',
        component: () => import('@/components/attend/pages/ServiceClosed.vue'),
        meta: { attendRequiresAuth: false },
    },
    {
        path: '*',
        redirect: { name: 'AttendServiceClosed' },
    },
]

export default RouterAttend
